<template>
  <div id="confirmOrder">
    <div>
      <h1>Pedido registrado exitósamente</h1>
      <p>
        Recibirás un link de pago en tu teléfono para completar la operación!
      </p>
      <p>Gracias!</p>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$store.commit("RESET_STATE");
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
#confirmOrder {
  height: 45em;
  position: relative;
}
#confirmOrder div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/ConfirmOrder.vue